<script>
    import { onMount } from 'svelte';
    import ResponsiveTable from '../../utils/responsivetable3.svelte';
    import Header from "../header.svelte";
    import { push } from 'svelte-spa-router';
    import { all_quotes_store, api_host, user_store, subdomain_manager } from '../../stores.js';
    import { init_data } from '../../init.js';
    import { getFullState, formatDate, formatPhoneNumber, handle_not_subscribed, sort_functions, capitalizeFirst } from '../../utils/format.js';
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { toast_message } from '../../utils/toast_message.js';
    import Swal from "sweetalert2";


    const { auth_type, auth_token, domain_code } = getToken();

    let is_busy = false;
    let is_mounted = false;
    let domain_name = null;
    let working_quotes = [];
    let quotes = [];
    let myself = {};

    subdomain_manager.subscribe(value => {
        domain_name = value;
        console.log('subdomain', domain_name);
    });

    user_store.subscribe(value => {
        myself = value;
    });
    function process_params(qs) {
        setTimeout(()=>{ window.scrollTo(0, 0); }, 100);
    }

    $: content_title = "Quotes";

    all_quotes_store.subscribe(value => {
        quotes = [];
        for (let i = 0; i < value.length; i ++) {
            const quote = value[i];
            quotes.push({
                "id": quote.id,
                "c": quote.email,
                "p": quote.total_service_price,
                "j": `${quote.address}, ${quote.city}, ${getFullState(quote.state)}`,
                "n": (!quote.service_user) ? // (quote.status === 'open' || !quote.service_user)
                    `${quote.first_name} ${quote.last_name}` :
                    `<a sortValue='${quote.first_name + " " + quote.last_name}' href='/#/User_Review?uid=${quote.service_user}'>${quote.first_name + " " + quote.last_name}</a>`,
                "hp": formatPhoneNumber(quote.home_phone),
                "cp": formatPhoneNumber(quote.mobile_phone),
                "d": formatDate(quote.created_at),
                "s": capitalizeFirst(quote.status),
                "st": quote.service_type
            });
        }

        working_quotes = quotes;
    });

    onMount(async () => {
        setTimeout(()=>{ is_mounted = true; }, 250);
    });

    let table_header_config = [
        {'t': 'ID', 'fm': 'id', 'a': false},
        {'t': 'Name', 'fm': 'n', 'a': true},
        {'t': 'Email', 'fm': 'c', 'a': true},
        {'t': 'Address', 'fm': 'j', 'a': true},
        {'t': 'Home Phone', 'fm': 'hp', 'a': false},
        {'t': 'Cell Phone', 'fm': 'cp', 'a': false},
        {'t': 'Service Type', 'fm': 'st', 'a': true},
        {'t': 'Price', 'fm': 'p', 'a': true},
        {'t': 'Date', 'fm': 'd', 'a': true},
        {'t': 'Status', 'fm': 's', 'a': true},
    ];

    let show_items = [
        {
            "id": "show",
            "i": "fas fa-eye",
            "s": "color: #1c54b2;",
            "f": (id) => { push("#/Quote_Review?qid=" + id); },
            "l": '#/Quote_Review?qid=<action_id>',
        },
    ];
    let action_items = [
        {"id": "delete", "i": "fas fa-trash-alt", "s": "color: #ab003c;", "f": async (id) => {
            Swal.fire({
                title: "Delete this quote?",
                text: '',
                buttonsStyling: true,
                confirmButtonClass: "button",
                confirmButtonText: 'Ok',
                cancelButtonText: "Cancel",
                showCancelButton: true,
                icon: "warning"
            }).then(async (e) => {
                is_busy = true;
                if (e.isConfirmed) {
                    const res = await doFetch(
                        `${api_host}/api/quote/delete`,
                        'POST',
                        { quote_id: id },
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    if (res.status) {
                        toast_message(true, res.msg, 2000);
                        init_data('quotes');
                        quotes = quotes.filter(quote => quote.id !== id);
                    } else {
                        toast_message(false, res.msg || 'Bad request', 2000);
                    }
                }
                is_busy = false;
            });
        }},
    ]

    let field_formats = {
        "p": (p) => {
            var formatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD',});
            return formatter.format(parseFloat(p));
        }
    };

    let field_styles = {
        "p": "text-align: right;"
    }

    let date_value = '';
</script>

<Header bind:title={content_title} bind:is_busy={is_busy} />
<div class="contentholder">
    <div class="buttonholder">
        <button class="create" on:click={() => {
            if (myself['is_subscribed'] !== undefined && !myself['is_subscribed']) {
                handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
                return;
            }
            if (!domain_name || domain_name == 'sample') {
                Swal.fire({
                    title: 'Domain',
                    text: 'Set up your domain first in Settings > Domain.',
                    icon: 'info',
                    confirmButtonText: 'OK'
                }).then((result) => {
                    if (result.isConfirmed) {
                        push("#/Settingsdomain");
                    }
                });
                return;
            }
            push("#/Quote_Create");
        }}><i class="far fa-file-plus"></i> New Quote</button>
    </div>
   
    <div class="section">
        <div class="invoicetableholder">
            <ResponsiveTable
                field_formats={field_formats}
                field_styles={field_styles}
                sort_functions={sort_functions}
                num_per_page={100}
                show_date_range={true}
                show_selections = {false}
                selections_title = 'Charge'
                date_filter_param='d'
                action_items_title='Remove'
                refresh_action='quotes'
                bind:is_busy={is_busy}
                bind:table_header_config={table_header_config}
                bind:table_data={working_quotes}
                bind:date_value={date_value}
                bind:total_items={working_quotes.length}
                bind:action_items={action_items}
                bind:show_items={show_items}
            />
        </div>
    </div>
</div>

<style>
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    :global(.rowwrap) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    .contentholder {
        padding: 0px;
    }
    .buttonholder {
        margin-top: 10px;
        margin-bottom: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .buttonholder button {
        max-width: 300px;
        background-color: #357a38;
        color: white;
    }
    :global(.flatpickr-input) {
        width: 250px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        :global(.rowwrap) {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }
        :global(.rowwrap .group) {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
        }
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button{
            max-width: 100%;
            width: 100%;
        }
        :global(.flatpickr-input) {
            width: 100%;
        }
    }
</style>